import ContactForm from '../components/sections/ContactForm';

const CONTACT_INFO = [
  {
    icon: '📍',
    title: 'Office Address',
    lines: [
      'T-5041, Sterling Ascentia,',
      'Opposite Bellandur,',
      'Bengaluru, Karnataka – 560103, India',
    ],
    action: null,
  },
  {
    icon: '📧',
    title: 'Email Us',
    lines: ['anirhealthcare@gmail.com', 'sanjeevkusingh@gmail.com'],
    action: 'mailto:anirhealthcare@gmail.com',
  },
  {
    icon: '📞',
    title: 'Call Us',
    lines: ['+91 82947 03147', '+91 79798 78458'],
    action: 'tel:+918294703147',
  },
  {
    icon: '🕐',
    title: 'Business Hours',
    lines: ['Mon – Sat: 9:00 AM – 6:00 PM', 'Sunday: Closed'],
    action: null,
  },
];

const SOCIAL = [
  {
    name: 'Instagram',
    handle: '@anirheathcare',
    href: 'https://www.instagram.com/anirheathcare?igsh=cmU2ZmZwYjh0YmE4',
    icon: (
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
      </svg>
    ),
    color: 'bg-gradient-to-br from-purple-500 to-pink-500',
  },
  {
    name: 'Facebook',
    handle: 'Anir HealthCare',
    href: 'https://www.facebook.com/share/1Evsowy5F1/',
    icon: (
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
      </svg>
    ),
    color: 'bg-blue-600',
  },
];

export default function ContactPage() {
  return (
    <div className="min-h-screen bg-[#f8faff]">
      {/* Hero */}
      <div className="bg-hero-gradient pt-12 pb-24 relative overflow-hidden">
        <div
          className="absolute inset-0 opacity-[0.04] pointer-events-none"
          style={{
            backgroundImage:
              'linear-gradient(white 1px, transparent 1px), linear-gradient(90deg, white 1px, transparent 1px)',
            backgroundSize: '40px 40px',
          }}
        />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative text-center">
          <p className="text-accent text-sm font-semibold tracking-widest uppercase mb-4">Reach Us</p>
          <h1 className="font-display text-5xl sm:text-6xl font-bold text-white mb-4">Contact Us</h1>
          <p className="text-blue-200 text-lg max-w-2xl mx-auto">
            Have a question, need product information, or interested in a partnership? We'd love to hear from you.
          </p>
        </div>
        <div className="absolute bottom-0 left-0 right-0">
          <svg viewBox="0 0 1440 60" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full">
            <path d="M0 60L60 50C120 40 240 20 360 15C480 10 600 20 720 25C840 30 960 30 1080 25C1200 20 1320 10 1380 5L1440 0V60H0Z" fill="#f8faff" />
          </svg>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-10">
          {/* Left: Contact Details */}
          <div className="lg:col-span-2 space-y-5">
            <div>
              <h2 className="font-display text-3xl font-bold text-primary-800 mb-2">Get in Touch</h2>
              <p className="text-slate-500 text-sm leading-relaxed">
                Our team is here to assist you. Reach out through any of the channels below.
              </p>
            </div>

            {/* Info cards */}
            <div className="space-y-4">
              {CONTACT_INFO.map((item) => (
                <div key={item.title} className="bg-white rounded-2xl p-5 shadow-card flex gap-4 items-start">
                  <div className="w-11 h-11 bg-blue-50 rounded-xl flex items-center justify-center text-xl flex-shrink-0">
                    {item.icon}
                  </div>
                  <div>
                    <p className="text-xs text-slate-400 font-semibold uppercase tracking-wide mb-1">{item.title}</p>
                    {item.lines.map((line, i) =>
                      item.action && i === 0 ? (
                        <a
                          key={line}
                          href={item.action}
                          className="block text-sm font-medium text-primary hover:underline"
                        >
                          {line}
                        </a>
                      ) : (
                        <p key={line} className="text-sm text-slate-700">{line}</p>
                      )
                    )}
                  </div>
                </div>
              ))}
            </div>

            {/* Social links */}
            <div>
              <p className="text-xs text-slate-400 font-semibold uppercase tracking-wide mb-3">Follow Us</p>
              <div className="flex gap-3">
                {SOCIAL.map((s) => (
                  <a
                    key={s.name}
                    href={s.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`flex items-center gap-2.5 px-4 py-2.5 ${s.color} text-white text-sm font-semibold rounded-xl hover:opacity-90 transition-opacity shadow-md`}
                  >
                    {s.icon}
                    <span>{s.handle}</span>
                  </a>
                ))}
              </div>
            </div>
          </div>

          {/* Right: Contact Form */}
          <div className="lg:col-span-3">
            <div className="bg-white rounded-3xl shadow-card p-8 lg:p-10">
              <h3 className="font-display text-2xl font-bold text-primary-800 mb-2">
                Send a Message
              </h3>
              <p className="text-slate-500 text-sm mb-8">
                Fill out the form below and we'll get back to you within one business day.
              </p>
              <ContactForm />
            </div>
          </div>
        </div>

        {/* Map placeholder */}
        <div className="mt-12 bg-white rounded-3xl shadow-card overflow-hidden">
          <div className="bg-gradient-to-br from-blue-50 to-indigo-100 h-64 flex flex-col items-center justify-center text-center px-6 gap-3">
            <div className="text-5xl">📍</div>
            <h3 className="font-display text-xl font-bold text-primary-800">
              T-5041, Sterling Ascentia, Bengaluru
            </h3>
            <p className="text-slate-500 text-sm">Opposite Bellandur, Karnataka – 560103, India</p>
            <a
              href="https://maps.google.com/?q=Sterling+Ascentia+Bellandur+Bengaluru"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary text-sm py-2.5 px-5 mt-2"
            >
              Open in Google Maps
              <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
